import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-warehouse-transfer-item-status-badge',
    templateUrl: './warehouse-transfer-item-status-badge.component.html',
    styleUrls: ['./warehouse-transfer-item-status-badge.component.css']
})
export class WarehouseTransferItemStatusBadgeComponent implements OnInit {

    @Input() status: string;

    constructor() { }

    ngOnInit() {
    }

}

